import {
	createContext,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import storageManager from '@/api/storageManager';
import { LANG_OPTIONS } from '@/common/constants/languages';
import { applyLanguage, readInitialLanguage } from '@/common/utils/language';

export { LANG_OPTIONS } from '@/common/constants/languages';

export const LanguageContext = createContext(null);

const LanguageContextProvider = ({ children }) => {
	const [lang, setLang] = useState(
		() => readInitialLanguage() ?? LANG_OPTIONS.english,
	);

	useEffect(() => {
		document.documentElement.lang = lang;
	}, [lang]);

	const switchLanguage = useCallback((nextLang) => {
		const token = storageManager.auth.getToken();
		const refreshToken = storageManager.auth.getRefreshToken();

		applyLanguage(nextLang, setLang, {
			transferAuth: Boolean(token),
			token,
			refreshToken,
		});
	}, []);

	const value = useMemo(
		() => ({
			lang,
			switchLanguage,
		}),
		[lang, switchLanguage],
	);

	return (
		<LanguageContext.Provider value={value}>
			{children}
		</LanguageContext.Provider>
	);
};

export default LanguageContextProvider;
